import { StyledForecastHeader, StyledSeparator } from './ForecastHeader.style';
import IssuesStates from './IssuesStates';
import RemainingDays from './RemainingDays';

const ForecastHeader = ({ forecast }) => {
  return (
    <StyledForecastHeader>
      <RemainingDays />
      <StyledSeparator />
      <IssuesStates forecast={forecast} />
    </StyledForecastHeader>
  );
};

export default ForecastHeader;
